<template>
  <div class="gift-list-popup">
    <img :src="pageInfo.img.bigPopup" />
    <a class="close" href="javascript:;" @click="closePopup"></a>
    <div class="content" :style="fontcolor">
      <p class="title" :style="mainColor">查詢獎勵</p>
      <div class="table">
        <table>
          <thead>
            <tr>
              <th :style="theadCss">獎勵</th>
              <th :style="theadCss">物品</th>
              <th :style="theadCss">禮包兌換碼</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table table-content" :style="borderColor">
        <table>
          <tbody>
            <tr>
              <td :style="borderColor">收藏禮包</td>
              <td :style="borderColor" v-html="favourGiftContent"></td>
              <td :style="borderColor">{{favourGiftCard}}</td>
            </tr>
            <tr>
              <td :style="borderColor">下載禮包</td>
              <td :style="borderColor" v-html="downloadGiftContent"></td>
              <td :style="borderColor">{{downloadGiftCard}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="tips" :style="mainColor" v-html="pageInfo.gift.exchangeTips"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    fontcolor() {
      return `color:${this.pageInfo.color.font}`;
    },
    mainColor() {
      return `color:${this.pageInfo.color.main}`;
    },
    borderColor() {
      return `border-color:${this.pageInfo.color.border}`;
    },
    theadCss() {
      return `border-color:${this.pageInfo.color.border};background-color:${this.pageInfo.color.tableBg}`;
    },
    favourGiftContent() {
      return this.giftState.like_award ? this.pageInfo.gift.favourContent : "-";
    },
    downloadGiftContent() {
      return this.giftState.download_award
        ? this.pageInfo.gift.downloadContent
        : "-";
    },
    favourGiftCard() {
      return this.giftState.like_award_card || "-";
    },
    downloadGiftCard() {
      return this.giftState.download_award_card || "-";
    },
    ...mapGetters(["giftState", "pageInfo"]),
  },
  methods: {
    closePopup() {
      this.$store.commit("updateState", {
        action: "giftListPopupState",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gift-list-popup {
  position: absolute;
  width: 628px;
  height: 437px;
  top: 50%;
  left: 50%;
  margin-left: -314px;
  margin-top: -218px;
  z-index: 20;
  box-sizing: border-box;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
    left: 0;
  }
  .close {
    position: absolute;
    z-index: 2;
    width: 50px;
    height: 50px;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .content {
    position: absolute;
    width: 100%;
    top: 0;
    text-align: center;
    font-size: 20px;
    .title {
      font-size: 28px;
      font-weight: 600;
      margin: 30px auto 20px;
    }
    .table {
      margin: auto 30px;
    }
    table {
      border-collapse: collapse;
      width: 100%;
      td,
      th {
        border: 1px solid #fff;
        line-height: 150%;
        font-size: 20px;
        width: 33%;
        text-align: center;
      }
      th {
        line-height: 300%;
        font-weight: 100;
        border-bottom: none;
      }
      td {
        padding: 3%;
      }
      tr {
        &:first-child {
          td {
            border-top: none;
          }
        }
      }
    }
    .table-content {
      max-height: 180px;
      overflow: auto;
      border-bottom: 1px solid white;
      border-left: 1px solid white;
      border-right: 1px solid white;
      &::-webkit-scrollbar {
        /* 滚动条宽 */
        width: 0;
      }
      scrollbar-color: transparent transparent;
      scrollbar-width: none;
      table tr {
        td {
          &:last-child {
            border-right: none;
          }
          &:first-child {
            border-left: none;
          }
        }
        &:last-child td {
          border-bottom: none;
        }
      }
    }
    .tips {
      font-size: 20px;
      line-height: 130%;
      margin: 30px 30px 0;
      text-align: left;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GiftListPopup.vue